import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import ChatSidebar from "./ChatSidebar";
import ChatWindow from "./ChatWindow";

import { getAuthToken } from "../../auth/auth";

const Chat = ({ userId }) => {
  const [selectedConversation, setSelectedConversation] = useState(null);
  const [allConversations, setAllConversations] = useState([]);
  const { conversation_id } = useParams();

  const token = getAuthToken();

  useEffect(() => {
    const fetchConversations = async () => {
      try {
        const res = await fetch(`/api/conversations`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) {
          throw new Error("Failed to fetch conversations");
        }

        const data = await res.json();
        setAllConversations(data);

        if (conversation_id) {
          const match = data.find((c) => c.id === parseInt(conversation_id));
          if (match) setSelectedConversation(match);
        }
      } catch (error) {
        console.error("Error fetching conversations:", error);
      }
    };

    fetchConversations();
  }, [conversation_id, token]);

  return (
    <div
      className="chat-container"
      style={{ display: "flex", height: "100vh" }}
    >
      <ChatSidebar
        token={token}
        userId={userId}
        conversations={allConversations}
        onSelectConversation={setSelectedConversation}
        selectedConversation={selectedConversation}
      />
      <div style={{ flex: 1, padding: "20px" }}>
        {selectedConversation ? (
          <ChatWindow
            conversationId={selectedConversation.id}
            token={token}
            userId={userId}
          />
        ) : (
          <div>Select a conversation</div>
        )}
      </div>
    </div>
  );
};

export default Chat;
